import { render, staticRenderFns } from "./VerificationDetailsAnchors.vue?vue&type=template&id=e81469c8&"
import script from "./VerificationDetailsAnchors.vue?vue&type=script&lang=js&"
export * from "./VerificationDetailsAnchors.vue?vue&type=script&lang=js&"
import style0 from "./VerificationDetailsAnchors.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports